import { render, staticRenderFns } from "./DrugHandoverQueue.vue?vue&type=template&id=6cf4ce41&scoped=true"
import script from "./DrugHandoverQueue.vue?vue&type=script&lang=js"
export * from "./DrugHandoverQueue.vue?vue&type=script&lang=js"
import style0 from "./DrugHandoverQueue.vue?vue&type=style&index=0&id=6cf4ce41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf4ce41",
  null
  
)

export default component.exports